import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";

export default function Step1({ progress, totalItems }) {
  const completedItems = Math.round((progress / 100) * totalItems);

  return (
    <>
      <Box mb={2}>
        <Typography fontWeight={500} fontSize={20}>
          Onsite Inventory to Warehouse Receiving
        </Typography>
      </Box>
      <Box my={6}>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          Creating receiving report and adding items...
        </Typography>
        <Box mt={3} px={4}>
          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{ height: 8, borderRadius: 4 }}
          />
        </Box>
        <Box mt={2}>
          <Typography variant="body2" color="textSecondary">
            {completedItems} of {totalItems} items processed
          </Typography>
        </Box>
      </Box>
    </>
  );
}
